import { Env } from '../../core/env';
import { ApiClient } from '../../core/http/api_client';
import { ItemRequestJsEnv } from '../../search/itemRequest/models/item_request_js_env';

export class ItemDemandRepository {
  async create (model: ItemRequestJsEnv) {
    const request = {
      itemMakerName: model.itemMakerName,
      itemName: model.itemName,
      makerModel: model.makerModel,
      janCode: model.standardCode,
      comment: model.comment,
      llCategoryCode: model.llCategoryCode,
      lCategoryCode: model.lCategoryCode,
      mCategoryCode: model.mCategoryCode,
      sCategoryCode: model.sCategoryCode,
      searchKeyword: model.searchKeyWord
    }
    return ApiClient.post(Env.SETTING.userPublicApi.urlBase + "api/attract/item/itemDemand", request);
  }
}
